import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"

export const getScopedDemands = api(async function getScopedDemands(scope, id, payload) {
    return query(
        gql`
            query GetScopedDemands($scope: String!, $id: String!, $payload: JSONObject) {
                getScopedDemands(scope: $scope, id: $id, payload: $payload)
            }
        `,
        { scope, id, payload },
        { returns: "getScopedDemands" }
    )
})
